module.exports = __webpack_public_path__ + "../resources/images/headshot-miguel-69e212d1d1bd309df1cbbad81529c30b.png";